<template>
    <button
            class="w-full relative rounded-lg"
            v-bind="$attrs"
            :class="classes"
            @click="onClick"
            :disabled="disable || busy"
            :style="buttonStyle"
    >
        <spinner v-if="busy" class="mr-2" size="1.2em"/>
        <span v-if="label" v-html="label"></span>
        <svg
                v-if="!hideIcon"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                class="absolute right-4"
                style="width: 1em; height: 1em;"
                fill="none"
        >
            <path style="fill: currentColor;" d="M10.9087 4.10754L15.7849 8.98375H1.23457C1.19195 8.98375 1.14985 8.98592 1.10834 8.99017C0.485798 9.05338 0 9.57911 0 10.2183C0 10.9002 0.552731 11.4529 1.23457 11.4529H15.7849L10.9087 16.3291C10.4266 16.8113 10.4266 17.5929 10.9087 18.0751C11.3908 18.5572 12.1725 18.5572 12.6546 18.0751L19.6384 11.0913C20.1205 10.6092 20.1205 9.8275 19.6384 9.34533L12.6546 2.36159C12.6471 2.35406 12.6395 2.34665 12.6318 2.33935C12.5781 2.28826 12.5209 2.24295 12.461 2.2034C12.1186 1.9774 11.6886 1.93974 11.3171 2.09039C11.1685 2.15066 11.0293 2.24106 10.9087 2.36159C10.9012 2.36913 10.8938 2.37674 10.8864 2.38441C10.4267 2.86808 10.4341 3.63294 10.9087 4.10754Z"/>
        </svg>

        <f-loading
                :showing="loading"
                overlay
                color="#FFFFFF"
        />
    </button>
</template>

<script>
import Spinner from '@/components/Spinner.vue'
import { objectifyClasses } from '@/services/Utils.js'

export default {
  name: 'NavButton',
  components: {
    Spinner
  },
  emits: ['click'],
  props: {
    label: {
      type: String
    },
    buttonClasses: {
      type: [Object, Array, String],
      default: function () {
        return [
          'text-backdrop'
        ]
      }
    },
    hideIcon: {
      type: Boolean
    },
    busy: {
      type: Boolean
    },
    disable: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    buttonStyle () {
      return {
        'font-size': '19px',
      }
    },
    classes () {
      return Object.assign({
        'inline-flex items-center justify-center focus:outline-none overflow-hidden': true,
        'py-3 px-5': true,
        'font-bold': true,
        'text-backdrop': true,
        'bg-green hover:bg-green-300 active:bg-green-300 transition-colors': !this.disable,
        'bg-slate-blue-600': this.disable
      }, objectifyClasses(this.buttonClasses))
    }
  },
  methods: {
    onClick (e) {
      if (this.busy || this.disable) return
      this.$emit('click', e)
    }
  }
}
</script>

<style scoped>

</style>
